import { useDispatch } from "react-redux";

import { setIsVisibleDentalFormulaModal } from "@/store/ui/ui";
import { ISearchDrawerProps } from "@/shared/interfaces/ui";
import AddformulaButton from "@/shared/components/AddFormulaButton/AddFormulaButton";

export default function ScheduleAppointmentFormula({
    toggleDrawer,
    isAppointmentComplete,
}: ISearchDrawerProps) {
    const dispatch = useDispatch();

    return (
        <div className='edit_drawer_container_formula drawer_item'>
            <AddformulaButton
                onClick={() => {
                    if (!isAppointmentComplete) {
                        toggleDrawer(false);
                        dispatch(setIsVisibleDentalFormulaModal(true));
                    }
                }}
            />
        </div>
    );
}
